import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles } from 'lucide-react';

/**
 * Mobile-first sticky bottom CTA — appears only on public SEO pages
 * (`/for/*`, `/region/*`, `/pros/*`). Single line of copy + one button
 * that funnels visitors into the role-appropriate signup at the bottom
 * of the viewport. Keeps the "what next?" question one-tap away while
 * the visitor reads the page.
 *
 * Hidden on `md:` and larger so it doesn't clutter desktop reading.
 * Visible on mobile + tablet where most NRI traffic actually arrives.
 */
const StickyMobileCTA = ({
  label = 'Find verified pros near you',
  ctaText = 'Get started',
  to = '/auth?role=buyer',
  dataTestId = 'sticky-mobile-cta',
}) => (
  <div
    className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-[#0F172A] text-white border-t border-white/10 shadow-2xl"
    data-testid={dataTestId}
  >
    <div className="flex items-center justify-between gap-3 px-4 py-3">
      <p className="text-xs leading-tight flex-1 min-w-0">
        <Sparkles className="inline h-3.5 w-3.5 text-[#E07A3A] mr-1" />
        <span className="truncate">{label}</span>
      </p>
      <Link
        to={to}
        className="bg-[#E07A3A] hover:bg-[#C4652E] text-white text-[11px] tracking-[0.15em] font-bold uppercase px-4 py-2 flex-shrink-0"
        data-testid={`${dataTestId}-btn`}
      >
        {ctaText}
      </Link>
    </div>
  </div>
);

export default StickyMobileCTA;
